var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.47644C0.5 2.87427 0.658035 3.2558 0.93934 3.5371C1.22064 3.81841 1.60218 3.97644 2 3.97644C2.39782 3.97644 2.77936 3.81841 3.06066 3.5371C3.34196 3.2558 3.5 2.87427 3.5 2.47644C3.5 2.07862 3.34196 1.69708 3.06066 1.41578C2.77936 1.13448 2.39782 0.97644 2 0.97644C1.60218 0.97644 1.22064 1.13448 0.93934 1.41578C0.658035 1.69708 0.5 2.07862 0.5 2.47644ZM0.5 9.97644C0.5 10.3743 0.658035 10.7558 0.93934 11.0371C1.22064 11.3184 1.60218 11.4764 2 11.4764C2.39782 11.4764 2.77936 11.3184 3.06066 11.0371C3.34196 10.7558 3.5 10.3743 3.5 9.97644C3.5 9.57862 3.34196 9.19709 3.06066 8.91578C2.77936 8.63448 2.39782 8.47644 2 8.47644C1.60218 8.47644 1.22064 8.63448 0.93934 8.91578C0.658035 9.19709 0.5 9.57862 0.5 9.97644ZM0.5 17.4764C0.5 17.8743 0.658035 18.2558 0.93934 18.5371C1.22064 18.8184 1.60218 18.9764 2 18.9764C2.39782 18.9764 2.77936 18.8184 3.06066 18.5371C3.34196 18.2558 3.5 17.8743 3.5 17.4764C3.5 17.0786 3.34196 16.6971 3.06066 16.4158C2.77936 16.1345 2.39782 15.9764 2 15.9764C1.60218 15.9764 1.22064 16.1345 0.93934 16.4158C0.658035 16.6971 0.5 17.0786 0.5 17.4764Z",
    fill: "#074173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot);
export default __webpack_public_path__ + "static/media/three_dot.1d679cc35ec61b9f590f7369be5cb6aa.svg";
export { ForwardRef as ReactComponent };